import { Component, Input, OnInit } from '@angular/core';
import ICalendar from '../../../../../_interfaces/ICalendar';
import moment from 'moment';
import { FormCreateAppointmentComponent } from '../../../../forms/form-create-appointment/form-create-appointment.component';
import { SessionService } from '../../../../../_services/session/session.service';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../../../base/base.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarView } from 'angular-calendar';
import { FormCalendarNoteComponent } from '../../../../forms/form-calendar-note/form-calendar-note.component';

@Component({
  selector: 'app-calendar-appointments-actions-buttons',
  imports: [CommonModule, ButtonModule, TooltipModule, TranslatePipe],
  templateUrl: './calendar-appointments-actions-buttons.component.html',
  styleUrl: './calendar-appointments-actions-buttons.component.scss',
})
export class CalendarAppointmentsActionsButtonsComponent
  extends BaseComponent
  implements OnInit
{
  @Input('calendar') calendars: ICalendar[];

  @Input('onAction') onAction: (config: {
    date?: Date;
    view?: CalendarView;
    retrieve: {
      appointments: boolean;
      notes: boolean;
    };
  }) => void;

  @Input('viewDate')
  public viewDate: Date = moment().toDate();

  constructor(
    public session: SessionService,
    private dialogService: DialogService,
    private translate: TranslateService,
  ) {
    super(session);
  }

  public addNote() {
    const ref = this.dialogService.open(FormCalendarNoteComponent, {
      closable: true,
      modal: true,
      width: '52rem',
      breakpoints: {
        '960px': '94vw',
        '640px': '98vw',
      },
      header: this.translate.instant('CALENDAR.NOTES.ADD'),
      inputValues: {
        calendar: this.calendars,
        onCreate: () => {
          ref.close();
          this.onAction({
            date: this.viewDate,
            retrieve: { notes: true, appointments: false },
          });
        },
      },
    });
  }

  public addAppointment() {
    this.dialogService.open(FormCreateAppointmentComponent, {
      width: '74rem',
      breakpoints: {
        '1280px': '90vw',
        '1200px': '92vw',
        '960px': '92vw',
        '640px': '98vw',
      },
      contentStyle: {
        height: 'min(82vh, 56rem)',
        'max-height': '82vh',
        overflow: 'hidden',
      },
      closable: true,
      modal: true,
      data: {
        calendars: this.calendars,
        callback: () => {
          this.onAction({ retrieve: { appointments: true, notes: false } });
        },
      },
      header: this.translate.instant('APPOINTMENT.ADD'),
    });
  }
}
